export default {
	entryPage: {
		title: "Start page",
		hint: "One HTML page, shown as the entry of every dataspace that runs this project. Write it with inline CSS and JavaScript.",
		editorLabel: "HTML of the start page",
		enabledLabel: "Show this page when a dataspace opens",
		enabledHint: "Off, the dataspace opens on its process list, as it always did.",
		unsavedNotShipped:
			"You have unsaved changes: the switch acts on the page as last saved, and a build ships that.",
		enabledOn: "The start page is on. The next build ships it.",
		enabledOff: "The start page is off.",
		// Said where an author writes the page, because it is the one thing that can go wrong
		// quietly: the values reach the browser of everyone who can open it.
		publicNotice:
			"The values of the variables this page reads (process.env.NAME) are visible to every member of the dataspace and to anyone who can open the page. Do not read secrets here.",
		saved: "Start page saved.",
		resetAction: "Reset",
		resetConfirm: "Discard the start page and switch it off?",
		reset: "Start page reset.",
		tooLarge: "The page is {size} KiB; at most {max} KiB can be saved.",
		notice: "The page runs in a sandbox. It can read its own variables and call window.notitia — nothing else of the app. openProcesses() and openProcess(id, options) open the Operator; the options take a query. startProcess(name, options) starts a process and resolves with its id once it is ready; the options take instanceName, description and restartRule, each optional. sendEvent(target, event, data) sends the event named event — what an Event Listener listens for — to a process id, or to every running instance when the target names a process, and resolves with how many it reached. A refusal rejects with an Error whose code says why.",
		previewTitle: "Preview",
		previewFrame: "Preview of the start page",
		previewEnvTitle: "Values for the preview",
		previewEnvHint:
			"Placeholder values, not saved. In a dataspace the page gets the values set there.",
		previewNoEnv: "This page reads no environment variables.",
		previewBridge: "{call} only works in a dataspace; nothing happens in the preview.",
		previewRefused: "A dataspace would refuse this request from the page: {message}",
	},
};
